/**
 * @file
 * Global utilities.
 *
 */
(function ($, Drupal, once) {
  "use strict";

  /**
   * Infinite scrolling progress indicator.
   *
   * @type {{attach: Drupal.behaviors.progressIndicator.attach}}
   */
  Drupal.behaviors.progressIndicator = {
    attach: function (context, settings) {
      if (typeof Drupal.Ajax !== "undefined") {
        Drupal.Ajax.prototype.setProgressIndicatorFullscreen = function () {
          this.progress.element = $(
            '<div class="ajax-progress ajax-progress-fullscreen">&nbsp;</div>'
          );
          $("body .pager").before(this.progress.element);
        };
      }
    },
  };

  Drupal.behaviors.xenter_theme = {
    attach: function (context, settings) {
      /**
       * Add target, noopener and aria-label to external links + icon if it is not a nav link and contains text
       */

      once("externalLinks", "a:not(.card--wrapper)", context).forEach(
        (element) => {
          const href = $(element).attr("href");

          if (
            element.host !== window.location.host &&
            href &&
            !href.startsWith("tel:") &&
            !href.startsWith("mailto:")
          ) {
            $(element).attr({ target: "_blank", rel: "noopener" });

            const ariaLabel =
              $(element).attr("aria-label") ||
              $(element).text().trim() ||
              $(element).attr("title");

            $(element).attr(
              "aria-label",
              ariaLabel ? `${ariaLabel}: Öppnas i ny flik` : "Öppnas i ny flik"
            );

            if (!$(element).hasClass("nav-link") && $(element).text().length) {
              $(element).addClass("icon-after icon-external-link");
            }
          }
        }
      );

      once("dwiseTrackingScript", ".application-cta-button", context).forEach(
        (element) => {
          let trackingId = element.dataset.courseid;

          if (trackingId) {
            element.addEventListener("click", (event) => {
              let _d7 = _d7 || [];

              let d = document.createElement("script"),
                s = document.getElementsByTagName("script")[0];
              _d7.id = trackingId;
              _d7.p =
                "https:" == document.location.protocol ? "https://" : "http://";
              d.src = _d7.p + "tb.de17a.com/d7.js";
              d.type = "text/javascript";
              d.async = 1;
              s.parentNode.insertBefore(d, s);
            });
          }
        }
      );

      const more = "Visa mer";
      const less = "Visa mindre";

      once("expander-button", ".expander-button", context).forEach(
        (element) => {
          $(element).attr("aria-label", more);

          $(element).click(function () {
            const isExpanded = $(this).attr("aria-expanded") === "true";
            $(this).attr("aria-expanded", !isExpanded);
            $(this).siblings(".expander-content").toggleClass("expanded");

            const ariaLabel = isExpanded ? more : less;
            $(this).attr("aria-label", ariaLabel);
          });
        }
      );

      /**
       * Add aria-label to search field on employee overview page
       */

      once("employee-overview-search-field", "#edit-title", context).forEach(
        (element) => {
          $(element).attr("aria-label", "Sök efter personal");
        }
      );

      /**
       * Close mobile menu with esc key when toggler is focused
       */

      $(document).keyup(function (e) {
        if (e.key === "Escape") {
          if (
            $("#CollapsingNavbar").hasClass("show") &&
            $(".navbar-toggler").is(":focus")
          ) {
            $(".navbar-toggler").click();
          }
        }
      });
    },
  };
})(jQuery, Drupal, once);
